import { apiClient } from "../lib/api";

export const dataQualityApi = {
  getSummary: () => apiClient.get("/data-quality/summary"),
  getRules: () => apiClient.get("/data-quality/rules"),
  listFindings: (params) => apiClient.get("/data-quality/findings", { params }),
  listFindingsPaginated: (params) => apiClient.get("/data-quality/findings", { params }),
  getFinding: (findingId) => apiClient.get(`/data-quality/findings/${findingId}`),
  exportFindings: (params) => apiClient.get("/data-quality/export", { params }),
  runScan: (module) => apiClient.post("/data-quality/scan", { module: module || null }),
  assign: (findingId, owner, due_date, notes) => apiClient.post(`/data-quality/findings/${findingId}/assign`, { owner, due_date, notes }),
  bulkAssign: (payload) => apiClient.post("/data-quality/findings/bulk-assign", payload),
  start: (findingId, notes) => apiClient.post(`/data-quality/findings/${findingId}/start`, { notes }),
  resolve: (findingId, resolution_note) => apiClient.post(`/data-quality/findings/${findingId}/resolve`, { resolution_note }),
  falsePositive: (findingId, reason) => apiClient.post(`/data-quality/findings/${findingId}/false-positive`, { reason }),
  acceptRisk: (findingId, reason, expires_at) => apiClient.post(`/data-quality/findings/${findingId}/accept-risk`, { reason, expires_at }),
  reopen: (findingId, reason) => apiClient.post(`/data-quality/findings/${findingId}/reopen`, { reason }),
};
